(function () {
  // ============================================================
  // ROUTED — CART DRAWER
  // ============================================================

  // const SHIPPING_THRESHOLD_CENTS = 7500; 
  let cart = null;
  let isOpen = false;
  let isUpdating = false;

  const drawer = document.querySelector('[data-routed-cart]');
  if (!drawer) return;

  const body = drawer.querySelector('[data-cart-body]');
  const footer = drawer.querySelector('[data-cart-footer]');
  const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  const countEl = drawer.querySelector('[data-cart-count]');
  const shippingEl = drawer.querySelector('[data-cart-shipping]');
  const closeBtns = drawer.querySelectorAll('[data-cart-close]');
  const checkoutBtn = drawer.querySelector('[data-cart-checkout]');

  // ============================================================
  // OPEN / CLOSE
  // ============================================================

  function openCart() {
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    isOpen = true;
    refreshCart();
  }

  function closeCart() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => {
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      isOpen = false;
    }, 350);
  }

  closeBtns.forEach((btn) => btn.addEventListener('click', closeCart));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen) closeCart();
  });

  // Header cart icon — intercept clicks to open drawer
  document.querySelectorAll('[data-cart-toggle]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      openCart();
    });
  });

  // Item link clicks — close drawer when navigating
  drawer.addEventListener('click', (e) => {
    const closer = e.target.closest('[data-cart-close-on-click]');
    if (closer) {
      setTimeout(closeCart, 100);
    }
  });

  // Listen for ATC events from PDP
  document.addEventListener('routed:cart:added', () => {
    openCart();
  });

  // ============================================================
  // CART FETCH + RENDER
  // ============================================================

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('Cart fetch failed');
      cart = await res.json();
      renderCart();
    } catch (err) {
      console.error('[Routed Cart] Refresh error', err);
    }
  }

  function renderCart() {
    if (!cart) return;

    // Update count
    if (countEl) countEl.textContent = `(${cart.item_count})`;

    // Update header cart count badges (anywhere on page)
    document.querySelectorAll('[data-header-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
    });

    // Update items body
    renderItems();

    // Update subtotal
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    // Footer visibility
    if (footer) {
      if (cart.item_count === 0) {
        footer.setAttribute('hidden', '');
      } else {
        footer.removeAttribute('hidden');
      }
    }

    // Free shipping progress
    // renderShipping();
  }

  function renderItems() {
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="routed-cart__empty">
          <p class="routed-cart__empty-text">Your cart is empty. Time to hit the road.</p>
          <a href="/collections/all" class="routed-cart__empty-cta" data-cart-close>Shop All Products &rarr;</a>
        </div>
      `;
      // Wire up empty-state close button
      body.querySelectorAll('[data-cart-close]').forEach((el) => {
        el.addEventListener('click', closeCart);
      });
      return;
    }

    let html = '<ul class="routed-cart__items" data-cart-items>';
    cart.items.forEach((item) => {
      html += renderItem(item);
    });
    html += '</ul>';
    body.innerHTML = html;
    attachItemHandlers();
  }

  function renderItem(item) {
    const optionsHTML = (item.options_with_values && item.options_with_values.length > 0 && !item.product_has_only_default_variant)
      ? `<div class="routed-cart__item-options">${item.options_with_values.map(o => `<span>${escapeHtml(o.name)}: ${escapeHtml(o.value)}</span>`).join('')}</div>`
      : '';

    const priceHTML = (item.original_line_price > item.final_line_price)
      ? `<span class="routed-cart__item-price-final routed-cart__item-price-sale">${formatMoney(item.final_line_price)}</span><s class="routed-cart__item-price-compare">${formatMoney(item.original_line_price)}</s>`
      : `<span class="routed-cart__item-price-final">${formatMoney(item.final_line_price)}</span>`;

    const imageUrl = item.image
      ? item.image.replace(/(\.[^.]+)$/, '_200x$1')
      : '';

    return `
      <li class="routed-cart__item" data-cart-item data-line-key="${escapeAttr(item.key)}">
        <a href="${escapeAttr(item.url)}" class="routed-cart__item-media" data-cart-close-on-click>
          ${imageUrl ? `<img src="${escapeAttr(imageUrl)}" alt="${escapeAttr(item.product_title)}" loading="lazy">` : ''}
        </a>
        <div class="routed-cart__item-info">
          <a href="${escapeAttr(item.url)}" class="routed-cart__item-title" data-cart-close-on-click>${escapeHtml(item.product_title)}</a>
          ${optionsHTML}
          <div class="routed-cart__item-row">
            <div class="routed-cart__qty">
              <button type="button" class="routed-cart__qty-btn" data-qty-decrease aria-label="Decrease quantity">
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
              </button>
              <input type="number" value="${item.quantity}" min="0" class="routed-cart__qty-input" data-qty-input aria-label="Quantity">
              <button type="button" class="routed-cart__qty-btn" data-qty-increase aria-label="Increase quantity">
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
              </button>
            </div>
            <div class="routed-cart__item-price">${priceHTML}</div>
          </div>
          <button type="button" class="routed-cart__item-remove" data-cart-remove aria-label="Remove ${escapeAttr(item.product_title)}">Remove</button>
        </div>
      </li>
    `;
  }


  function renderShipping() {
    if (shippingEl) shippingEl.innerHTML = '';
  }

  // ============================================================
  // ITEM HANDLERS (qty, remove)
  // ============================================================

  function attachItemHandlers() {
    body.querySelectorAll('[data-cart-item]').forEach((itemEl) => {
      const lineKey = itemEl.dataset.lineKey;
      const decBtn = itemEl.querySelector('[data-qty-decrease]');
      const incBtn = itemEl.querySelector('[data-qty-increase]');
      const input = itemEl.querySelector('[data-qty-input]');
      const removeBtn = itemEl.querySelector('[data-cart-remove]');

      const updateQty = (newQty) => {
        if (isUpdating) return;
        const qty = Math.max(0, parseInt(newQty, 10) || 0);
        updateLine(lineKey, qty, itemEl);
      };

      if (decBtn) decBtn.addEventListener('click', () => {
        const current = parseInt(input.value, 10) || 0;
        updateQty(current - 1);
      });

      if (incBtn) incBtn.addEventListener('click', () => {
        const current = parseInt(input.value, 10) || 0;
        updateQty(current + 1);
      });

      if (input) {
        input.addEventListener('change', () => updateQty(input.value));
        input.addEventListener('blur', () => updateQty(input.value));
      }

      if (removeBtn) removeBtn.addEventListener('click', () => updateQty(0));

      // Close drawer when clicking item title/image links
      itemEl.querySelectorAll('[data-cart-close-on-click]').forEach((el) => {
        el.addEventListener('click', () => {
          setTimeout(closeCart, 100);
        });
      });
    });
  }

  async function updateLine(lineKey, quantity, itemEl) {
    if (isUpdating) return;
    isUpdating = true;
    if (itemEl) itemEl.classList.add('is-removing');

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: lineKey, quantity })
      });

      if (!res.ok) throw new Error('Update failed');
      cart = await res.json();
      renderCart();
    } catch (err) {
      console.error('[Routed Cart] Update error', err);
      if (itemEl) itemEl.classList.remove('is-removing');
    } finally {
      isUpdating = false;
    }
  }

  // ============================================================
  // CHECKOUT
  // ============================================================

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', () => {
      window.location.href = '/checkout';
    });
  }

  // ============================================================
  // HELPERS
  // ============================================================

  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function escapeAttr(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  // ============================================================
  // INITIAL LOAD
  // ============================================================

  refreshCart();
})();